import React, { useEffect, useRef } from "react";

export default function SpecialistModal({
  selected,
  displayed,
  index,
  setIndex,
  prevMaterial,
  nextMaterial,
  isVideo,
  setSelected,
  likes,
  toggleLike
}) {
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  // Закрытие по ESC
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setSelected(null);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [setSelected]);

  // Обработчики свайпов
  const onTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].clientX;
  };

  const onTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    const diff = touchStartX.current - touchEndX.current;

    if (Math.abs(diff) < 50) return;

    if (diff > 0) nextMaterial();
    else prevMaterial();
  };

  if (!selected) return null;

  return (
    <div
      onClick={() => setSelected(null)}
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "8px",
          width: "80%",
          maxWidth: "600px",
          position: "relative"
        }}
      >
        {/* Крестик */}
        <span
          onClick={() => setSelected(null)}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "28px",
            cursor: "pointer",
            backgroundColor: "rgba(128,128,128,0.3)",
            color: "#fff",
            borderRadius: "50%",
            width: "35px",
            height: "35px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000
          }}
        >
          ×
        </span>

        {/* Сердечко лайка */}
        <span
          onClick={() => toggleLike(selected.uuid)}
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            fontSize: "26px",
            cursor: "pointer",
            userSelect: "none",
            color: likes.includes(selected.uuid) ? "red" : "#aaa",
            zIndex: 1000
          }}
        >
          {likes.includes(selected.uuid) ? "❤️" : "🤍"}
        </span>

        <h2 style={{ textAlign: "center" }}>{selected.firstname}</h2>

        {/* Карусель */}
        <div
          style={{ position: "relative", textAlign: "center" }}
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          {displayed.length > 0 && (
            <>
              {isVideo(displayed[index]) ? (
                <video
                  src={displayed[index]}
                  muted
                  playsInline
                  style={{ width: "100%", borderRadius: "8px", cursor: "pointer" }}
                  onClick={(e) => {
                    if (e.target.paused) e.target.play();
                    else e.target.pause();
                    e.target.muted = false;
                  }}
                />
              ) : (
                <img
                  src={displayed[index]}
                  alt=""
                  style={{ width: "100%", borderRadius: "8px" }}
                />
              )}

              {displayed.length > 1 && (
                <>
                  <span
                    onClick={prevMaterial}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "10px",
                      fontSize: "36px",
                      cursor: "pointer",
                      userSelect: "none",
                      backgroundColor: "rgba(128,128,128,0.3)",
                      color: "rgba(200,200,200,0.8)",
                      borderRadius: "50%",
                      width: "35px",
                      height: "35px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1000
                    }}
                  >
                    ‹
                  </span>

                  <span
                    onClick={nextMaterial}
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      fontSize: "36px",
                      cursor: "pointer",
                      userSelect: "none",
                      backgroundColor: "rgba(128,128,128,0.3)",
                      color: "rgba(200,200,200,0.8)",
                      borderRadius: "50%",
                      width: "35px",
                      height: "35px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1000
                    }}
                  >
                    ›
                  </span>
                </>
              )}
            </>
          )}
        </div>

        {/* Точки-индикаторы */}
        <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "12px" }}>
          {displayed.map((_, i) => (
            <span
              key={i}
              onClick={() => setIndex(i)}
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: i === index ? "#333" : "#ccc",
                cursor: "pointer"
              }}
            />
          ))}
        </div>

        {/* Кнопка записи */}
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <a
              href={selected.bookingUrl}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#042204ff",
              color: "#fff",
              cursor: "pointer"
            }}
          >
            Выбрать время
          </a>
        </div>
      </div>
    </div>
  );
}
